import * as React from "react";
import { PrismicContext } from "./PrismicProvider.js";
const usePrismicContext = () => {
  return React.useContext(PrismicContext) || {};
};
export {
  usePrismicContext
};
//# sourceMappingURL=usePrismicContext.js.map
